const initCodes = () => {
    document.querySelectorAll('.ks-codes').forEach((section) => {
        const filters = section.querySelectorAll('[data-codes-filter]');
        const categories = section.querySelectorAll('[data-codes-category]');

        if (!filters.length || !categories.length) {
            return;
        }

        const applyFilters = () => {
            const activeFilters = Array.from(filters)
                .filter((filter) => filter.checked)
                .map((filter) => filter.value);

            categories.forEach((category) => {
                const categorySlug = category.dataset.category || '';
                const isVisible = !activeFilters.length || activeFilters.includes(categorySlug);

                category.classList.toggle('d-none', !isVisible);
            });
        };

        filters.forEach((filter) => {
            filter.addEventListener('change', applyFilters);
        });

        applyFilters();
    });
};

export default initCodes;
